import { createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_GET } from "@grudder/app/actions-client";
import { config } from "@grudder/lib/config";
import { setCustomModules } from "@grudder/redux/slice/custom-modules";
import { setUserPermissions } from "@grudder/redux/slice/permissions";
import { setPrimarySources } from "@grudder/redux/slice/primary-sources";
import { setSources } from "@grudder/redux/slice/sources";
import { setStages } from "@grudder/redux/slice/stages";
import { setStatuses } from "@grudder/redux/slice/statuses";
import { setAllowedUsers, setAllUsers } from "@grudder/redux/slice/users";
import { setUser } from "@grudder/redux/slice/user";
import { setUserSettings } from "@grudder/redux/slice/user-settings";
import { setAllUserGroups } from "@grudder/redux/slice/user-groups";
import { IUserBootstrapApiResponse } from "@grudder/types/api-response.type";
import { IOrganizationUser } from "@grudder/types/organization.types";

interface FetchBootstrapParams {
    userId: string;
}

export const fetchUserBootstrap = createAsyncThunk(
    "bootstrap/fetchUserBootstrap",
    async ({ userId }: FetchBootstrapParams, { dispatch }) => {
        try {
            // Fetch all required data
            const userBootstrap: IUserBootstrapApiResponse = await AUTH_GET(
                `${config.baseURL}/api/users/bootstrap`,
                {
                    revalidate: 0,
                    tags: ["user-bootstrap"],
                }
            );

            const usersList = await AUTH_GET(`${config.baseURL}/api/users?limit=100`, {
                revalidate: 0,
                tags: ["allowed-users"],
            });

            const userGroups = await AUTH_GET(
                `${config.baseURL}/api/user-groups?limit=100`,
                {
                    revalidate: 0,
                    tags: ["user-groups"],
                }
            );

            // Dispatch direct bootstrap data
            dispatch(setStages(userBootstrap.stages.data));
            dispatch(setStatuses(userBootstrap.statuses.data));
            dispatch(setCustomModules(userBootstrap.customModules.data));
            dispatch(setUserPermissions(userBootstrap.userPermissions.data));
            dispatch(setPrimarySources(userBootstrap.primarySources.data));
            dispatch(setSources(userBootstrap.sources.data));
            dispatch(setAllUserGroups(userGroups.data));

            // Format and dispatch user data
            const formattedUsers = userBootstrap.organizationUsers.data.map(
                (user: IOrganizationUser) => ({
                    ...user?.user,
                    role: user?.role,
                    organizationUserId: user?._id,
                })
            );
            dispatch(setAllUsers(formattedUsers));
            dispatch(setAllowedUsers(usersList?.data));

            const userDetails = userBootstrap?.organizationUsers?.data?.find(
                (user: IOrganizationUser) => user?.user?._id === userId
            );
            dispatch(setUser(formattedUsers));

            if (userDetails?.user?.userSettings) {
                dispatch(setUserSettings(userDetails.user.userSettings));
            }

            return userBootstrap;
        } catch (error) {
            console.error("Error fetching bootstrap data:", error);
            throw error;
        }
    }
);
